import { IPixelData } from '../types/layers';

export const colorize = (pixelData: IPixelData, threshold: Array<number> = [-0.3, 0.3]) => {
  if (pixelData == null || pixelData.pixelBlock == null || pixelData.pixelBlock.pixels === null) {
    return;
  }

  let pixelBlock = pixelData.pixelBlock;
  const pixels = pixelBlock.pixels;
  let mask = pixelBlock.mask;
  const numPixels = pixelBlock.width * pixelBlock.height;

  if (pixels == null) {
    return;
  }

  const computedValues = pixels[0];
  const rBand = new Uint8Array(computedValues.length); //set up array for red values
  const gBand = new Uint8Array(computedValues.length); //set up array for green values
  const bBand = new Uint8Array(computedValues.length); //set up array for blue values

  if (mask == null) {
    mask = new Uint8Array(computedValues.length); //mask = new Uint8Array(p1.length);
    pixelBlock.mask = mask;
  }

  //if pixel value lies between slider min and max, display it (set value to 1)
  //if not, don't display it (set the value to 0)
  for (var i = 0; i < numPixels; i++) {
    mask[i] =
      computedValues[i] === 0 || (computedValues[i] >= threshold[0] && computedValues[i] <= threshold[1]) ? 0 : 1;

    //apply color based on temperature value of each pixel
    if (mask[i]) {
      if (computedValues[i] > threshold[1]) {
        rBand[i] = 0;
        gBand[i] = 255;
        bBand[i] = 0;
      } else {
        rBand[i] = 255;
        gBand[i] = 0;
        bBand[i] = 0;
      }
    }
  }

  pixelData.pixelBlock.pixels = [rBand, gBand, bBand]; //assign rgb values to each pixel
  // pixelData.pixelBlock.statistics = null;
  pixelData.pixelBlock.pixelType = 'U8';
};

export const colorizeHansen = (pixelData: IPixelData) => {
  // If there isn't pixelData, a pixelBlock, nor pixels, exit the function
  if (pixelData === null || pixelData.pixelBlock === null || pixelData.pixelBlock.pixels === null) {
    return;
  }

  // The pixelBlock stores the values of all pixels visible in the view
  var pixelBlock = pixelData.pixelBlock;

  // The number of pixels in the pixelBlock
  var numPixels = pixelBlock.width * pixelBlock.height;

  // Create empty arrays for each of the RGB bands to set on the pixelBlock
  var rBand = [];
  var gBand = [];
  var bBand = [];

  // Loop through all the pixels in the view to make them pink
  for (let i: number = 0; i < numPixels; i++) {
    rBand[i] = 255;
    gBand[i] = 20;
    bBand[i] = 147;
  }

  // Set the new pixel values on the pixelBlock (now three bands)
  pixelData.pixelBlock.pixels = [rBand, gBand, bBand];
  pixelData.pixelBlock.pixelType = 'u8'; // u8 is used for color
};
